module.exports = __webpack_public_path__ + "img/gongzhonghao.a08b9e2f.jpg";